module.exports = __webpack_public_path__ + "img/twitter.7178f677.png";